import styled from 'styled-components'

import { DASHBOARD_STYLED_CONSTS } from '@components'
import { Tabs, mediaQueries } from '@fourthwall/components'

export const Tab = styled(Tabs.Item)`
  &:last-child {
    padding-right: ${DASHBOARD_STYLED_CONSTS.CONTENT_PADDING_HORIZONTAL}px;

    ${mediaQueries.tablet} {
      padding-right: 0;
    }
  }
`
